export enum AccountPurpose {
  LOAN = 'LOAN',
  INVEST = 'INVEST',
  AGENT = 'AGENT',
}
